import React, { useEffect, useState } from "react";
import "./Product_description.css";
import Common_breadcrumb from "../common-components/common-breadcrumb/Common_breadcrumb";
import StarRatings from "react-star-ratings";
import { useParams, useLocation } from "react-router-dom";

import Favourite_icon from "../common-components/favourite-icon/Favourite_icon";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCartShopping } from "@fortawesome/free-solid-svg-icons";
import Product_slider from "./product-slider/Product_slider";
import Product_details from "./product-details/Product_details";
import Product_ratings from "./product-ratings/Product_ratings";
import Our_recommendation from "./our-recommendation/Our_recommendation";
import Newslater from "../home/newslater/Newslater";
import Product_info from "./product-info/Product_info";
import {
  getAllOURProduct,
  getAllProducts,
  getProduct,
} from "../../features/products/productsSlice";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllRatings,
  getAvgRatings,
} from "../../features/rating/ratingSlice";
import { decodeId } from "../../utils/common";
import Chat_Bot from "./chat-bot/Chat_Bot";
import Common_Back_Header from "../common-components/common_back_header/Common_Back_Header";
import { getAllPriceRange } from "../../features/master/masterSlice";

const Product_description = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const [variant, setVariant] = useState({});
  const { id } = useParams();
  const dispatch = useDispatch();
  const product = useSelector((state) => state.product.product);

  const [deid, setDeid] = useState(null);

  // useEffect(() => {
  //   if (!id) return;
  //   const decoded = decodeId(id);
  //   setDeid(decoded);
  //   dispatch(getProduct(decoded));
  // }, [dispatch, id]);

  const [loading, setLoading] = useState(true);
  useEffect(() => {
    if (!id) return;

    const fetchData = async () => {
      setLoading(true);

      const decoded = decodeId(id);
      setDeid(decoded);

      await dispatch(getProduct(decoded));

      setLoading(false);
    };

    fetchData();
  }, [dispatch, id]);

  useEffect(() => {
    if (product?.Product_Variants?.length > 0) {
      setVariant(product.Product_Variants[0]);
    }
  }, [product]);
  const priceRange = useSelector((state) => state.master.price_range);
  const lowest = Number(priceRange?.lowest_price) || 0;
  const highest = Number(priceRange?.highest_price) || 0;
  const productPrice = Number(product?.price) || 0;
  // const minPrice = Math.min(productPrice, lowest);
  // const maxPrice = Math.max(productPrice, highest);

  const minPrice = Math.floor(productPrice * 0.8);
  const maxPrice = Math.ceil(productPrice * 1.2);
  useEffect(() => {
    dispatch(getAllPriceRange());
  }, [dispatch]);
  const AllProduct = useSelector((state) => state.product.allOurProducts);
  useEffect(() => {
    dispatch(
      getAllOURProduct({
        category_id: product?.p_category_id,
        brand_id: product?.brand_id,
        priceRange: [minPrice, maxPrice],
      }),
    );
  }, [dispatch, product]);

  useEffect(() => {
    if (product?.Product_Variants?.length > 0) {
      setVariant(product.Product_Variants[0]);
    }
  }, [product]);

  const all_review = useSelector((state) => state.rating.ratings);

  useEffect(() => {
    dispatch(getAllRatings({ product_id: deid }));
  }, [dispatch, deid]);

  const avgrating = useSelector((state) => state.rating.avgRatings);
  useEffect(() => {
    dispatch(getAvgRatings({ id: deid }));
  }, [dispatch, deid]);

  const location = useLocation();
  const cameFromCollection = location.state?.from === "collection";

  if (loading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "100vh" }}
      >
        <div className="spinner-border text-danger" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }
  return (
    <>
      <section className="Product_description_sec">
       {/* <Common_breadcrumb
          items={[
            { label: "Home", link: "/" },
            { label: "Collection", link: "/all-products" },
            { label: product?.name },
          ]}
        />*/}

        <div className="container">
          <Common_Back_Header backNavigation="/all-products" />

          <div className="product_main_row row ">
            {/* LEFT SIDE → IMAGE */}
            <div className="col-lg-6 col-md-6 col-12">
              <Product_slider product={product} variant={variant} />
            </div>

            {/* RIGHT SIDE → PRODUCT INFO */}
            <div className="col-lg-6 col-md-6 col-12">
              <Product_info
                avgrating={avgrating}
                product_id={deid}
                product={product}
                setVariant={setVariant}
                variant={variant}
              />
            </div>
          </div>

          {/* BELOW SECTIONS */}
          <Product_details product={product} variant={variant} />

          {all_review?.length > 0 && (
            <Product_ratings all_review={all_review} avgrating={avgrating} />
          )}

          <Our_recommendation
            products={AllProduct}
            variant={variant}
            product={product}
          />
          <Newslater product={product} variant={variant} />
        </div>
      </section>
    </>
  );
};

export default Product_description;
